import type { CSSProperties, HTMLAttributeReferrerPolicy, ImgHTMLAttributes, ReactElement, ReactEventHandler, } from 'react';
import { motion } from 'framer-motion';
import type { TargetAndTransition, Transition } from 'framer-motion';
import { CIMAGE_LOADING_EAGER } from './cimage-constants';
type CimageLoading = NonNullable<ImgHTMLAttributes<HTMLImageElement>['loading']>;
type CimageDecoding = NonNullable<ImgHTMLAttributes<HTMLImageElement>['decoding']>;
interface CimageDynamicRendererProps {
    alt: string;
    ariaHidden?: boolean;
    decoding: CimageDecoding;
    draggable?: boolean;
    imageAnimate: false | TargetAndTransition;
    imageExit: TargetAndTransition;
    imageInitial: false | TargetAndTransition;
    imageStyle: CSSProperties;
    loading: CimageLoading;
    onError: ReactEventHandler<HTMLImageElement>;
    onLoad: ReactEventHandler<HTMLImageElement>;
    priority?: boolean;
    referrerPolicy?: HTMLAttributeReferrerPolicy;
    renderedSrc: string;
    setImageRef: (img: HTMLImageElement | null) => void;
    title?: string;
    transition: Transition;
}
export function CimageDynamicRenderer({ alt, ariaHidden, decoding, draggable, imageAnimate, imageExit, imageInitial, imageStyle, loading, onError, onLoad, priority, referrerPolicy, renderedSrc, setImageRef, title, transition, }: CimageDynamicRendererProps): ReactElement {
    return (
    <motion.img key={renderedSrc} ref={setImageRef} src={renderedSrc} alt={alt} title={title} loading={priority ? CIMAGE_LOADING_EAGER : loading} decoding={decoding} referrerPolicy={referrerPolicy} draggable={draggable} aria-hidden={ariaHidden} onLoad={onLoad} onError={onError} initial={imageInitial} animate={imageAnimate} exit={imageExit} transition={transition} style={imageStyle}/>
    );
}
